<template>
    <b-container class="discount-coupon">
        <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
            <form action="#" method="post" @submit.prevent="handleSubmit(addCoupon)">
                <div class="">
                    <div class="form-group">
                        <ValidationProvider name="Cupom desconto" :rules="{ required: false }" slim>
                            <div slot-scope="{ errors, classes, required }">
                                <label for="cupom" class="discount-coupon-title">Cupom desconto</label>
                                <div class="input-group mt-3">
                                    <input type="text" class="form-control" id="cupom" name="cupom" v-model="cupom" :disabled="$store.state.order.order.discount_coupon.cupom != ''">
                                    <span class="input-group-append">
                                        <button type="submit" class="btn-default btn-square py-0" v-if="$store.state.order.order.discount_coupon.cupom == ''" :disabled="$store.state.order.order.discount_coupon.cupom != ''">
                                            <span v-if="!loading">Aplicar</span>
                                            <span v-if="loading" class="ml-1">
                                                <span> Aplicando </span>
                                                <b-spinner small label="Loading..."></b-spinner>
                                            </span>
                                        </button>
                                        <button type="button" class="btn-default btn-square py-0" @click="removeCoupon" v-else>
                                            <span>Remover</span>
                                        </button>
                                    </span>
                                </div>
                                <small v-show="errors[0]" class="color-error">
                                    {{ errors[0] }}
                                </small>
                                <div v-html="$store.state.order.order.discount_coupon.descricao" class="discount-coupon-options"></div>
                                <div v-show="msg_completa" class="discount-coupon-error mt-3" v-html="msg_completa"></div>
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
            </form>
        </ValidationObserver>
    </b-container>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate";

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    props: {
        order: {
            default: () => ({})
        }
    },
    data: function () {
        return {
            cupom: '',
            descricao: '',
            msg_completa: '',
            produtos_validos: [],
            applied: false,
            loading: false
        }
    },
    mounted() {
        this.cupom = this.$store.state.order.order.discount_coupon.cupom
        this.coupon()
    },
    methods: {
        addCoupon() {
            if (this.cupom === '') {
                return false;
            }
            this.loading = true
            const params = new URLSearchParams();
            params.append('metodo', 'adicionar');
            params.append('cupom', this.cupom);
            this.$axios.$post(`/?p=ecommerce_cupom_desconto_api_v1`, params)
            .then((response) => {
                this.msg_completa = this.msgDiscountCoupon(response.msg_completa)
                this.$store.dispatch('order/loadOrder')
                this.loading = false
            })
            .catch((error) => {
                this.loading = false
                console.error(error);
                alert(error);
            })
        },
        removeCoupon() {
            this.loading = true
            const params = new URLSearchParams();
            params.append('metodo', 'remover');
            this.$axios.$post(`/?p=ecommerce_cupom_desconto_api_v1`, params)
            .then((response) => {
                this.msg_completa = this.msgDiscountCoupon(response.msg_completa)
                if (response.msg === 'sucesso') {
                    this.loading = false
                    this.$store.dispatch('order/loadOrder')
                }
            })
            .catch((error) => {
                this.loading = false
                console.error(error);
                alert(error);
            })
        },
        msgDiscountCoupon(msg) {
            switch (msg) {
                case 'data_fim_invalida':
                    return "Cupom expirado";
                case 'grupo_usuario':
                    return "Cupom não disponível para este usuário";
                case 'limite_cupons':
                case 'limite_cupons_pessoa':
                    return "Cupom já utilizado!";
                case '0':
                case 'Sem cupom':
                    return "";
                case 0:
                case 'produto_diferente':
                    return "Cupom não aplicável para este produto!";
                case 'cupom_nao_existe':
                    return "Cupom não existe!";
                case 'frete_faixa_cep_':
                    return "Cupom não existe!";
                default:
                    return msg;
            }
        },
        coupon() {
            try {
                // this.produtos_validos = this.$store.state.order.order.discount_coupon.produtos_validos
                this.msg_completa = this.msgDiscountCoupon(this.$store.state.order.order.discount_coupon.msg_completa)
            } catch (e) {
                console.error(e)
            }
        }
    },
    watch: {
        order: {
            handler(newval) {
                this.coupon()
            }
        },
        '$store.state.order.order.discount_coupon.cupom'(newval) {
            this.cupom = newval
        }
    }
}
</script>
